import { escapeRegExp } from "@swivl-mono/helpers";

const highlightText = (text: string, query?: string) => {
  if (!query) return text;

  const safeQuery = escapeRegExp(query);
  const regex = new RegExp(`(${safeQuery})`, "gi");

  return text.split(regex).map((part, index) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <span key={index} className="text-orange-500">
        {part}
      </span>
    ) : (
      <span key={index}>{part}</span>
    )
  );
};

export { highlightText };
